export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '热门电影在线观看，高清流畅不卡顿' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', description: '最新电视剧全集在线播放' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line', description: '热门综艺节目高清在线看' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '热门动漫番剧在线追番' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '精选纪录片在线观看' },
  { slug: 'duanju', name: '短剧', icon: 'ri-smartphone-line', description: '精彩短剧全集在线看' },
];

export const videos = [
  {
    id: 'v001',
    title: '流浪地球3：星际远征',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20poster%20featuring%20astronauts%20floating%20in%20deep%20space%20with%20a%20massive%20spaceship%20in%20the%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20cosmic%20background%20with%20stars%2C%20warm%20orange%20and%20gold%20accents&width=800&height=450&seq=video-cover-001&orientation=landscape',
    rating: 9.2,
    year: 2025,
    duration: '148分钟',
    description: '人类文明面临新的挑战，星际远征队踏上前往未知星系的旅程，探索人类新家园的无限可能。',
    tags: ['科幻', '冒险', '国产大片'],
    views: '1280万',
    updateTime: '2025-07-28',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v002',
    title: '长安三万里2：盛世华章',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20palace%20at%20sunset%20with%20poets%20in%20traditional%20robes%2C%20golden%20warm%20lighting%2C%20artistic%20ink%20painting%20style%2C%20cinematic%20atmosphere%2C%20beautiful%20composition%20with%20red%20lanterns&width=800&height=450&seq=video-cover-002&orientation=landscape',
    rating: 9.0,
    year: 2025,
    duration: '168分钟',
    description: '盛唐风华再现，诗人与艺术家齐聚长安，谱写中华文化最辉煌的篇章。',
    tags: ['动画', '历史', '文化'],
    views: '980万',
    updateTime: '2025-07-25',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v003',
    title: '逆流而上',
    category: 'dianshiju',
    categoryName: '电视剧',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20with%20young%20professionals%20in%20a%20modern%20office%2C%20warm%20natural%20light%2C%20cinematic%20TV%20series%20poster%20style%2C%20clean%20contemporary%20aesthetic&width=800&height=450&seq=video-cover-003&orientation=landscape',
    rating: 8.8,
    year: 2025,
    duration: '36集',
    description: '一群年轻人在都市中奋斗拼搏，面对职场和生活的挑战，逆流而上追逐梦想的故事。',
    tags: ['都市', '职场', '励志'],
    views: '2560万',
    updateTime: '2025-07-30',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v004',
    title: '山河令之风云再起',
    category: 'dianshiju',
    categoryName: '电视剧',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20with%20warriors%20in%20flowing%20robes%20on%20a%20misty%20mountain%2C%20dramatic%20lighting%2C%20warm%20golden%20sunset%20tones%2C%20cinematic%20wuxia%20aesthetic&width=800&height=450&seq=video-cover-004&orientation=landscape',
    rating: 8.6,
    year: 2025,
    duration: '48集',
    description: '江湖风云变幻，侠客们再次踏上征程，在恩怨情仇中寻找真正的武林正道。',
    tags: ['古装', '武侠', '爱情'],
    views: '1890万',
    updateTime: '2025-07-27',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v005',
    title: '笑傲江湖2025',
    category: 'zongyi',
    categoryName: '综艺',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20colorful%20lighting%20and%20performers%2C%20entertaining%20atmosphere%2C%20bright%20warm%20stage%20lights%2C%20audience%20cheering%2C%20dynamic%20composition&width=800&height=450&seq=video-cover-005&orientation=landscape',
    rating: 8.5,
    year: 2025,
    duration: '第12期',
    description: '顶级喜剧人同台竞技，用幽默和智慧带来一场场精彩绝伦的表演盛宴。',
    tags: ['喜剧', '竞技', '热门'],
    views: '3200万',
    updateTime: '2025-07-31',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v006',
    title: '歌手·巅峰对决',
    category: 'zongyi',
    categoryName: '综艺',
    cover: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20singer%20under%20dramatic%20spotlight%2C%20atmospheric%20concert%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20emotional%20performance%20moment&width=800&height=450&seq=video-cover-006&orientation=landscape',
    rating: 9.1,
    year: 2025,
    duration: '第8期',
    description: '华语乐坛顶级歌手齐聚一堂，用歌声诠释音乐的力量，巅峰对决震撼人心。',
    tags: ['音乐', '竞技', '热门'],
    views: '4500万',
    updateTime: '2025-08-01',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v007',
    title: '星辰大海：宇宙探索',
    category: 'dongman',
    categoryName: '动漫',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20space%20adventure%20scene%20with%20colorful%20nebula%20and%20spaceship%2C%20beautiful%20art%20style%2C%20warm%20cosmic%20colors%2C%20dreamy%20atmosphere%2C%20detailed%20animation%20quality&width=800&height=450&seq=video-cover-007&orientation=landscape',
    rating: 9.3,
    year: 2025,
    duration: '更新至24话',
    description: '在浩瀚星海中，少年探险队驾驶星际飞船，探索未知星球和文明奇迹。',
    tags: ['科幻', '冒险', '少年'],
    views: '1560万',
    updateTime: '2025-07-29',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v008',
    title: '仙王的日常生活5',
    category: 'dongman',
    categoryName: '动漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20scene%20with%20cultivation%20immortal%20in%20ancient%20Chinese%20setting%2C%20flowing%20robes%2C%20magical%20energy%20effects%2C%20warm%20golden%20ethereal%20lighting&width=800&height=450&seq=video-cover-008&orientation=landscape',
    rating: 8.9,
    year: 2025,
    duration: '更新至16话',
    description: '修仙日常继续，仙王在凡间的生活充满欢笑与感动，新一季带来更多惊喜。',
    tags: ['修仙', '搞笑', '日常'],
    views: '2100万',
    updateTime: '2025-07-30',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v009',
    title: '地球脉动：亚洲篇',
    category: 'jilupian',
    categoryName: '纪录片',
    cover: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20Asian%20landscapes%2C%20mountains%20and%20rivers%2C%20warm%20natural%20lighting%2C%20wildlife%20in%20natural%20habitat%2C%20breathtaking%20cinematography&width=800&height=450&seq=video-cover-009&orientation=landscape',
    rating: 9.6,
    year: 2025,
    duration: '8集全',
    description: '穿越亚洲大陆，从喜马拉雅到热带雨林，展现地球上最壮丽的自然奇观和生物多样性。',
    tags: ['自然', '地理', 'BBC级别'],
    views: '890万',
    updateTime: '2025-07-20',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v010',
    title: '霸道总裁的小甜心',
    category: 'duanju',
    categoryName: '短剧',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20modern%20drama%20scene%20with%20couple%20in%20elegant%20settings%2C%20warm%20soft%20lighting%2C%20sweet%20atmosphere%2C%20high%20quality%20cinematic%20look%2C%20clean%20contemporary%20style&width=800&height=450&seq=video-cover-010&orientation=landscape',
    rating: 8.2,
    year: 2025,
    duration: '80集全',
    description: '甜蜜爱情短剧，霸道总裁与天真女孩的浪漫邂逅，每一集都让人心动不已。',
    tags: ['爱情', '甜宠', '短剧'],
    views: '5600万',
    updateTime: '2025-07-31',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v011',
    title: '暗夜追踪者',
    category: 'dianying',
    categoryName: '电影',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20crime%20thriller%20movie%20poster%20with%20detective%20in%20rainy%20city%20street%20at%20night%2C%20neon%20light%20reflections%2C%20dark%20atmospheric%20mood%2C%20cinematic%20noir%20style&width=800&height=450&seq=video-cover-011&orientation=landscape',
    rating: 8.7,
    year: 2025,
    duration: '132分钟',
    description: '城市深夜，连环案件频发，一位资深刑警踏上追踪真相的危险之旅。',
    tags: ['悬疑', '犯罪', '动作'],
    views: '760万',
    updateTime: '2025-07-26',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v012',
    title: '美食中国：寻味之旅',
    category: 'jilupian',
    categoryName: '纪录片',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20scene%20with%20traditional%20dishes%20on%20rustic%20table%2C%20warm%20natural%20lighting%2C%20steam%20rising%20from%20hot%20food%2C%20artistic%20culinary%20photography&width=800&height=450&seq=video-cover-012&orientation=landscape',
    rating: 9.4,
    year: 2025,
    duration: '10集全',
    description: '走遍中国大江南北，探寻各地美食背后的文化与故事，每一口都是人间至味。',
    tags: ['美食', '文化', '旅行'],
    views: '1200万',
    updateTime: '2025-07-22',
    isHot: false,
    isNew: false,
  },
];

export const articleDetail = {
  id: 'v001',
  title: '流浪地球3：星际远征',
  category: 'dianying',
  categoryName: '电影',
  cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20poster%20featuring%20astronauts%20floating%20in%20deep%20space%20with%20a%20massive%20spaceship%20in%20the%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20cosmic%20background%20with%20stars%2C%20warm%20orange%20and%20gold%20accents&width=1600&height=900&seq=video-detail-001&orientation=landscape',
  rating: 9.2,
  year: 2025,
  duration: '148分钟',
  description: '在《流浪地球3：星际远征》中，人类文明面临前所未有的挑战。随着太阳系环境持续恶化，地球联合政府决定派出星际远征队，前往比邻星系探索人类新家园的可能性。\n\n影片讲述了以航天员刘启为首的中国远征队在浩瀚宇宙中的冒险旅程。他们穿越虫洞、遭遇未知文明、在异星生存，每一步都充满危险与挑战。在漫长的星际旅途中，队员们不仅要面对外部的威胁，还要克服内心的恐惧与孤独。\n\n这不仅是一部科幻大片，更是一部关于人类勇气、团结与希望的史诗。当人类的命运悬于一线，每一个选择都可能改变文明的未来。影片以宏大的宇宙视角、精良的特效制作和深刻的人文关怀，为观众呈现了一场视听与心灵的双重盛宴。',
  content: '《流浪地球3：星际远征》延续了前作的宏大叙事，将故事背景从太阳系拓展到了整个银河。导演以独特的视角展现了人类在绝境中的坚韧与智慧。\n\n电影的特效制作达到了国产科幻片的新高度，星际场景的呈现令人叹为观止。从虫洞穿越到异星地表，每一帧画面都精雕细琢。\n\n演员阵容方面，不仅有老戏骨的精彩演绎，更有新生代演员的亮眼表现。影片中的人物塑造立体饱满，情感线交织其中，让这部科幻片充满了温度。\n\n配乐同样是一大亮点，交响乐与电子音效的融合营造出了宏大而神秘的宇宙氛围，与画面完美契合。',
  tags: ['科幻', '冒险', '国产大片', '刘慈欣', '郭帆'],
  views: '1280万',
  updateTime: '2025-07-28',
  director: '郭帆',
  actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
  relatedVideos: ['v002', 'v007', 'v011'],
};

export const aboutInfo = {
  brandName: '嫩草视频',
  slogan: '高清流畅，即点即看',
  introduction: '嫩草视频成立于2023年，是一家专注于在线视频内容聚合与分发的互联网平台。我们致力于为广大用户提供高清流畅的视频观影体验，让每一位用户都能随时随地享受优质的影视内容。\n\n平台汇集了海量电影、电视剧、综艺、动漫、纪录片等各类视频资源，覆盖国内外热门内容。凭借先进的内容分发技术和智能推荐算法，嫩草视频能够为用户精准推荐感兴趣的影片，让观影更加轻松愉快。\n\n我们始终坚持"用户至上"的理念，不断优化产品体验，提升内容质量。无论是手机网页版还是电脑端，用户都能享受到流畅不卡顿的高清画质。无需下载APP，打开网页即可观看，方便快捷。',
  features: [
    { title: '高清画质', description: '支持1080P高清播放，画面清晰细腻，带来影院级观影体验', icon: 'ri-4k-line' },
    { title: '流畅不卡顿', description: '采用先进的CDN加速技术，确保视频播放流畅稳定', icon: 'ri-speed-line' },
    { title: '海量资源', description: '收录数万部影视作品，涵盖电影、电视剧、综艺、动漫等', icon: 'ri-database-2-line' },
    { title: '无需下载', description: '手机网页版直接观看，不占内存，即点即看', icon: 'ri-smartphone-line' },
    { title: '智能推荐', description: '基于用户喜好智能推荐，发现更多精彩内容', icon: 'ri-magic-line' },
    { title: '多端同步', description: '手机、平板、电脑多端同步观看记录', icon: 'ri-device-line' },
  ],
  testimonials: [
    { name: '张先生', avatar: '张', content: '嫩草视频真的太好用了，画质清晰还不卡顿，每天下班回家就看剧放松。', rating: 5 },
    { name: '李女士', avatar: '李', content: '手机上直接看很方便，不用下载APP，节省了好多空间，资源也很全。', rating: 5 },
    { name: '王同学', avatar: '王', content: '追番必备！动漫更新快，画质好，推荐给所有二次元朋友。', rating: 5 },
    { name: '刘先生', avatar: '刘', content: '纪录片资源很丰富，周末宅家看纪录片太舒服了，画质也很棒。', rating: 4 },
  ],
  contact: {
    email: 'contact@nencaovideo.com',
    wechat: 'nencaovideo',
    qq: '1234567890',
    workingHours: '周一至周日 9:00 - 21:00',
    address: '北京市朝阳区互联网科技园区A座',
  },
};

export const faqList = [
  { question: '嫩草视频需要下载APP吗？', answer: '不需要。嫩草视频支持手机网页版直接观看，无需下载安装任何APP，打开浏览器即可观看高清视频。' },
  { question: '视频播放卡顿怎么办？', answer: '建议检查网络连接状态，确保WiFi或移动数据信号良好。如仍有卡顿，可尝试切换清晰度或刷新页面。' },
  { question: '如何在手机上看视频？', answer: '使用手机浏览器打开嫩草视频网站即可观看，支持iOS和Android系统，体验流畅。' },
  { question: '支持哪些清晰度？', answer: '支持流畅、高清、超清多种清晰度选择，最高支持1080P全高清画质。' },
  { question: '视频更新频率如何？', answer: '热门电影电视剧和综艺节目持续更新，力争第一时间为观众带来最新内容。' },
];